import { renderOutro } from "./OutroLogic";
import OutroOverlay from "./OutroOverlay";
import { Outlink, Question, Registration } from "./Types";

export type OutroProps = {
  mode?: string;
  title?: string;
  withTopPadding?: boolean;
  noPadding?: boolean;
  alignedToTop?: boolean;
};

export type OutroPropsExtented = OutroProps & {
  icons: IIcons;
  onOpen?: () => void;
  onClose: () => void;
};

export type OutroState = {};

export { Outlink, OutroOverlay, Question, Registration, renderOutro };
